import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import fr from './fr.json'
import en from './en.json'

export const resources = {
  fr: { translation: fr },
  en: { translation: en },
}

export function initI18n(lng = 'en') {
  if (!i18n.isInitialized) {
    i18n.use(initReactI18next).init({
      resources,
      lng,
      fallbackLng: lng,
      interpolation: { escapeValue: false },
    })
  }
  return i18n
}

export default i18n